import React, { useContext } from 'react'
import { ThemeContext } from "../../Context/ThemeContext.js"; import './Footer.css'
import bscdao from '../../images/bscdaosqr.png'
import social1 from '../../images/social1.png'
import telegram from '../../images/telegram.png'
import twitter from '../../images/twitter.png'
import discord from '../../images/discord.png'
import social1L from '../../images/social1-light.png'
import telegramL from '../../images/telegram-light.png'
import twitterL from '../../images/twitter-light.png'
import discordL from '../../images/discord-light.png'

const Footer = () => {
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;
    return (
        <div className="footer">
            <div className="about-us">
               <a href="/"> <img src={bscdao} alt="" /></a>
                <div className="footer-menu">
                    <span>Doc</span>
                    <span>Twitter</span>
                    <span>Whitepaper</span>
                </div>
            </div>
            <div className="copyright">
                <span>© 2022 BSCDAO, All right Reserved</span>
                <div className="social">
                    <div className='social-item'><img src={` ${darkMode ? social1 : social1L}`} alt="" /></div>
                    <div className='social-item'><img src={` ${darkMode ? twitter : twitterL}`} alt="" /></div>
                    <div className='social-item'><img src={` ${darkMode ? telegram : telegramL}`} alt="" /></div>
                    <div className='social-item'><img src={` ${darkMode ? discord : discordL}`} alt="" /></div>
                </div>
            </div>
        </div>
    )
}

export default Footer